import { useEffect, useRef } from 'react';
// useEffect 또는 useCallback deps 노란줄에서 벗어나보자고 만든 값 참조 전용 hook
var useStateRef = function (initialValue) {
    var stateRef = useRef(initialValue);
    useEffect(function () {
        stateRef.current = initialValue;
    }, [initialValue]);
    return stateRef;
};
export default useStateRef;
